import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"
import * as styles from './header.module.scss'

class Header extends React.Component {
  render() {
    return (
    <div className={styles.headerContainer}>
      <header>
        <div className={styles.headerContainerCenter}>
          <Link
              to="/"
              className={styles.headerLinkHome}>
            <StaticImage className={styles.headerLogo} 
              src='../images/logo/header-logo.png' 
              alt='Halo Heatmaps'/>
          </Link>
          <div
            className={styles.aboutLink}>
            <Link to="/about/">About</Link>
          </div>
        </div>
      </header>
    </div>
    )}
  }

export default Header
